import { ProductGroup } from "ProductGrid/types";
import { ProductGridState } from "./types";
import buildStateKeyForProduct from "./buildStateKeyForProduct";
import { CaseReducer, PayloadAction, Action } from "@reduxjs/toolkit";

enum ProductGridStateActionType {
  TOGGLE = "toggle",
  RESET = "reset",
  TOGGLE_ATTRIBUTION = "toggleAttribution",
  TOGGLE_ALL_SELECTED = "toggleAllSelected",
}
type ToggleActionPayload = ProductGroup;
type ResetActionPayload = {
  products: ProductGroup[];
};

type buildInitialSelectionStateArgs = {
  products: ProductGroup[];
};
const buildInitialSelectionState = ({
  products,
}: buildInitialSelectionStateArgs) => ({
  selectedState: products.reduce(
    (acc, product) => ({
      ...acc,
      [buildStateKeyForProduct(product)]: {
        selected: false,
        colorId: product.colorId,
      },
    }),
    {}
  ),
});

const reset: CaseReducer<
  ProductGridState,
  PayloadAction<ResetActionPayload>
> = (state, action) => {
  const { products } = action.payload;
  const newState = {
    ...state,
    ...buildInitialSelectionState({ products }),
  };
  return newState;
};
const toggleAttribution: CaseReducer<ProductGridState, Action> = (
  prevState
) => {
  return {
    ...prevState,
    shouldShowAttribution: !prevState.shouldShowAttribution,
  };
};
const toggleAllSelected: CaseReducer<ProductGridState, Action> = (
  prevState
) => {
  const prevSelectedState = prevState.selectedState;
  const allAlreadySelected = Object.values(prevSelectedState).every(
    (state) => state && state.selected
  );
  const newSelectionState = Object.entries(prevSelectedState).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: {
        selected: !allAlreadySelected,
        colorId: value?.colorId ?? "",
      },
    }),
    {} as ProductGridState["selectedState"]
  );
  return {
    ...prevState,
    selectedState: newSelectionState,
  };
};
const toggle: CaseReducer<
  ProductGridState,
  PayloadAction<ToggleActionPayload>
> = (prevState, action) => {
  const prevSelectedState = prevState.selectedState;
  const stateKey = buildStateKeyForProduct(action.payload);
  const prevValue = prevSelectedState[stateKey];
  const newSelectedState = {
    ...prevSelectedState,
    [stateKey]: {
      selected: !prevValue?.selected,
      colorId: prevValue?.colorId ?? "",
    },
  };
  return {
    ...prevState,
    selectedState: newSelectedState,
  };
};

const reducers = {
  [ProductGridStateActionType.RESET]: reset,
  [ProductGridStateActionType.TOGGLE_ATTRIBUTION]: toggleAttribution,
  [ProductGridStateActionType.TOGGLE]: toggle,
  [ProductGridStateActionType.TOGGLE_ALL_SELECTED]: toggleAllSelected,
};
export default reducers;
